import React from 'react';
import { faMoon, faSun } from '@fortawesome/pro-regular-svg-icons';
import { faSignOutAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BatchDefinition } from 'components/breadcrumbs/BatchDefinition';
import { BatchDefinitions } from 'components/breadcrumbs/BatchDefinitions';
import { Batches } from 'components/breadcrumbs/Batches';
import { Job } from 'components/breadcrumbs/Job';
import { JobDefinition } from 'components/breadcrumbs/JobDefinition';
import { JobDefinitions } from 'components/breadcrumbs/JobDefinitions';
import { Jobs } from 'components/breadcrumbs/Jobs';
import { Projects } from 'components/breadcrumbs/Projects';
import { ScheduledBatch } from 'components/breadcrumbs/ScheduledBatch';
import { ScheduledBatches } from 'components/breadcrumbs/ScheduledBatches';
import { useAppDispatch } from 'ducks/hooks';
import { clearUser } from 'ducks/user/slices';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { routes } from 'routes';
import { deleteStorage } from 'utils/storage';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

export const Breadcrumbs = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { is_dark_theme, theme, setLocalStorageTheme } = useSwitchTheme();

  const logout = () => {
    try {
      dispatch(clearUser());
      deleteStorage();
      navigate('/login');
    } catch {
      throw new Error('Unable to clear store');
    }
  };

  const {
    ALL,
    PROJECTS,
    BATCHES,
    BATCH_DEFINITIONS,
    BATCH_DEFINITION,
    SCHEDULED_BATCHES,
    SCHEDULED_BATCH,
    JOBS,
    JOB,
    JOB_DEFINITIONS,
    JOB_DEFINITION,
  } = routes;

  const handleThemeChange = () => {
    setLocalStorageTheme(!is_dark_theme);
  };

  const { navigation_background, navigation_border } = theme;
  return (
    <nav
      className={cn.navigation}
      style={{
        backgroundColor: navigation_background,
        borderBottom: navigation_border,
      }}
    >
      <Routes>
        <Route path={PROJECTS.path} element={<Projects />} />
        <Route path={JOBS.path} element={<Jobs />} />
        <Route path={JOB.path} element={<Job />} />
        <Route path={BATCHES.path} element={<Batches />} />
        <Route path={JOB_DEFINITIONS.path} element={<JobDefinitions />} />
        <Route path={JOB_DEFINITION.path} element={<JobDefinition />} />
        <Route path={BATCH_DEFINITIONS.path} element={<BatchDefinitions />} />
        <Route path={SCHEDULED_BATCHES.path} element={<ScheduledBatches />} />
        <Route path={SCHEDULED_BATCH.path} element={<ScheduledBatch />} />
        <Route path={BATCH_DEFINITION.path} element={<BatchDefinition />} />
        <Route path={ALL.path} element={<div className={cn.flexGrow} />} />
      </Routes>
      <div className={cn.changeTheme} style={{ backgroundColor: navigation_background }} onClick={handleThemeChange}>
        <div className={cn.themeIcon}>
          <FontAwesomeIcon icon={!is_dark_theme ? faMoon : faSun} color="#FFFFFF" />
        </div>
        <div className={cn.themeText}>{!is_dark_theme ? 'Dark' : 'Light'}</div>
      </div>
      <div className={cn.logout} onClick={logout} style={{ backgroundColor: navigation_background }}>
        <FontAwesomeIcon icon={faSignOutAlt} color="white" className={cn.signOutIcon} />
        <span className={cn.logoutText}>Logout</span>
      </div>
    </nav>
  );
};
